"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TRAVEL_CLASS_CONFIG = exports.DEFAULT_TRAVEL_CLASS = exports.DEFAULT_TRANSLATIONS = exports.DEFAULT_PASSENGER_STEPPER_CONFIG = void 0;
var DEFAULT_PASSENGER_STEPPER_CONFIG = {
  min: 1,
  max: 9,
  adult: {
    type: 'adult',
    label: 'Adult',
    subLabel: 'Above 12 years',
    min: 'infant'
  },
  child: {
    type: 'child',
    label: 'Child',
    subLabel: 'From 2 to 11 years',
    min: 0
  },
  infant: {
    type: 'infant',
    label: 'Infant',
    subLabel: 'Under 2 years',
    min: 0,
    max: 'adult'
  },
  passengerCount: {
    adult: 1,
    child: 0,
    infant: 0
  }
};
exports.DEFAULT_PASSENGER_STEPPER_CONFIG = DEFAULT_PASSENGER_STEPPER_CONFIG;
var DEFAULT_TRAVEL_CLASS_CONFIG = [{
  title: 'Economy',
  value: 'economy',
  alignCenter: true,
  borderColor: 'greyLight'
}, // {
//   title: 'Premium Economy',
//   value: 'premium_economy',
//   alignCenter: true,
//   borderColor: 'greyLight',
// },
{
  title: 'Business',
  value: 'business',
  alignCenter: true,
  borderColor: 'greyLight'
} // {
//   title: 'First Class',
//   value: 'first_class',
//   alignCenter: true,
//   borderColor: 'greyLight',
// },
];
exports.DEFAULT_TRAVEL_CLASS_CONFIG = DEFAULT_TRAVEL_CLASS_CONFIG;
var DEFAULT_TRANSLATIONS = {
  flightPaxSelectorTitle: {
    single: '{{count}} Guest',
    plural: '{{count}} Guests'
  },
  flightPaxSelectorWithTravelClassTitle: {
    single: '{{count}} Guest, {{travelClass}}',
    plural: '{{count}} Guests, {{travelClass}}'
  },
  mixTravelTitle: 'Apply mixed travel class',
  mixTravelSubtitle: 'Book multiple travel classes in one itinerary',
  doneButtonLabel: 'Done',
  flightPaxSelectorMainTitle: 'Guests and travel class',
  travelClassTitle: 'Travel Class'
};
exports.DEFAULT_TRANSLATIONS = DEFAULT_TRANSLATIONS;
var DEFAULT_TRAVEL_CLASS = 'Economy';
exports.DEFAULT_TRAVEL_CLASS = DEFAULT_TRAVEL_CLASS;